import { useEffect, useState } from "react";

export interface GlobalMarket {
  total_market_cap_usd: number;
  total_volume_24h_usd: number;
  market_cap_change_percentage_24h_usd: number;
  btc_dominance: number;
  eth_dominance: number;
  active_cryptocurrencies: number;
  fearGreed?: { value: number; label: string };
}

const COINGECKO = "https://api.coingecko.com/api/v3";

export function useGlobalMarket() {
  const [data, setData] = useState<GlobalMarket | null>(null);
  const [lastUpdate, setLastUpdate] = useState<Date | null>(null);

  useEffect(() => {
    let cancelled = false;
    let globalTimer: number | undefined;
    let fgTimer: number | undefined;

    const fetchGlobal = async () => {
      if (document.visibilityState !== "visible") return;
      try {
        const res = await fetch(`${COINGECKO}/global`);
        if (!res.ok) return;
        const json = await res.json();
        const d = json.data;
        if (cancelled) return;
        setData(prev => ({
          ...(prev || ({} as GlobalMarket)),
          total_market_cap_usd: d.total_market_cap?.usd ?? 0,
          total_volume_24h_usd: d.total_volume?.usd ?? 0,
          market_cap_change_percentage_24h_usd: d.market_cap_change_percentage_24h_usd ?? 0,
          btc_dominance: d.market_cap_percentage?.btc ?? 0,
          eth_dominance: d.market_cap_percentage?.eth ?? 0,
          active_cryptocurrencies: d.active_cryptocurrencies ?? 0,
        }));
        setLastUpdate(new Date());
      } catch {/* ignore */}
    };

    const fetchFG = async () => {
      try {
        const res = await fetch("https://api.alternative.me/fng/?limit=1");
        if (!res.ok) return;
        const json = await res.json();
        const item = json?.data?.[0];
        if (!item || cancelled) return;
        setData(prev => ({
          ...(prev || ({} as GlobalMarket)),
          fearGreed: { value: Number(item.value), label: item.value_classification },
        }));
      } catch {/* ignore */}
    };

    fetchGlobal();
    fetchFG();
    globalTimer = window.setInterval(fetchGlobal, 30_000);
    fgTimer = window.setInterval(fetchFG, 5 * 60_000);

    return () => {
      cancelled = true;
      if (globalTimer) clearInterval(globalTimer);
      if (fgTimer) clearInterval(fgTimer);
    };
  }, []);

  return { data, lastUpdate };
}
